// Поиск и сортировка списка букетов в каталоге админки (Каталог → Букеты).
// Правила те же, что у стеблей в ProductsPage: подстрока названия без учёта регистра,
// категория по-русски, «без категории» — в конец, «Виден» по возрастанию = скрытые сначала,
// числовые колонки по возрастанию с первого клика (как «Остаток» у стеблей).
// Чистая функция — вынесена из BouquetsPage, чтобы покрыть тестом без рендера.

const collator = (a, b) => a.localeCompare(b, 'ru');

const COMPARATORS = {
  name: (a, b) => collator((a.name || '').trim(), (b.name || '').trim()),
  price: (a, b) => (a.final_price ?? a.price ?? 0) - (b.final_price ?? b.price ?? 0),
  category: (a, b) => collator(a.category?.name || 'я', b.category?.name || 'я'),
  // Колонка «Собрано» — физически собранные партии (то же число, что в строке)
  assembled: (a, b) => (a.physical_quantity || 0) - (b.physical_quantity || 0),
  // asc: скрытые сначала (как у стеблей: is_hidden=1 раньше 0)
  hidden: (a, b) => (b.is_hidden ? 1 : 0) - (a.is_hidden ? 1 : 0),
  // asc: с флагом «только собранные» сначала
  assembledOnly: (a, b) => (b.assembled_only ? 1 : 0) - (a.assembled_only ? 1 : 0),
};

/**
 * @param {Array} bouquets — как отдаёт /bouquets/all/list
 * @param {{searchName?: string, sortField?: string|null, sortDir?: 'asc'|'desc'}} opts
 * @returns {Array} новый массив: отфильтрованный по названию и отсортированный
 */
// Клик по дню в шапке: sortField = 'day:YYYY-MM-DD' — наверху букеты, которые можно
// собрать на эту дату (больше — выше), с нулём — вниз; при равенстве — по названию.
export const DAY_SORT_PREFIX = 'day:';
const capOn = (b, iso) => (b.daily_availability || []).find(d => d.date === iso)?.capacity || 0;

export function sortBouquets(bouquets, { searchName = '', sortField = null, sortDir = 'asc' } = {}) {
  const needle = searchName.trim().toLowerCase();
  const filtered = needle
    ? bouquets.filter(b => (b.name || '').toLowerCase().includes(needle))
    : [...bouquets];
  if (sortField && sortField.startsWith(DAY_SORT_PREFIX)) {
    const iso = sortField.slice(DAY_SORT_PREFIX.length);
    return filtered.sort((a, b) => (capOn(b, iso) - capOn(a, iso)) || COMPARATORS.name(a, b));
  }
  const cmp = COMPARATORS[sortField];
  if (!cmp) return filtered;
  const sign = sortDir === 'desc' ? -1 : 1;
  return filtered.sort((a, b) => sign * cmp(a, b));
}
